import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';

interface UnsavedChangesModalProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function UnsavedChangesModal({
  open,
  onConfirm,
  onCancel,
}: UnsavedChangesModalProps) {
  return (
    <Dialog open={open} onClose={onCancel} id="unsaved-changes-modal">
      <DialogTitle>Xác nhận rời khỏi</DialogTitle>
      <DialogContent>
        <Typography>
          Bạn có thay đổi chưa lưu. Bạn có chắc muốn rời khỏi?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} variant="outlined">
          Tiếp tục chỉnh sửa
        </Button>
        <Button onClick={onConfirm} variant="contained" color="error">
          Rời khỏi
        </Button>
      </DialogActions>
    </Dialog>
  );
}
